module.exports = __webpack_public_path__ + "img/cover_pages.f0f592cc.png";